import {InjectionToken} from "@angular/core";

export function getEmailAddress(program: string) {
  switch (program) {
    case 'FTC': return 'contact@ftc.nexus';
    default: return 'contact@frc.nexus';
  }
}

export const PROGRAM = new InjectionToken<'FRC'|'FTC'>('program');
